import React, { useEffect, memo, useState } from "react";
import {
    Switch,
    useColorModeValue,
    Tooltip,
    HStack,
    VStack,
    SimpleGrid,
    GridItem,
    Grid,
    Divider,
    Button,
    TagLabel,
    Tag,
    useDisclosure,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Flex,
    useMediaQuery,
    Checkbox,
    Box,
    Center,
    Text,
    Heading,
} from "@chakra-ui/react";
import { getAccount, getAuthUrl, updateUser } from "../../utils/sessionHelper";
import { useSession } from "next-auth/react";
import * as analytics from "../../utils/analytics";
import { useRouter } from "next/dist/client/router";
import { textStyle, variant } from "theme/names";

export const AskAuth = ({callback=undefined as Function | undefined}) => {
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"


    const router = useRouter();

    return (
      <Box display="flex" justifyContent="center">
        <Center maxW="400px" mt={20} display="flex" flexDirection="column">
          <Text mb={2}
            textStyle={textStyle["body.bold.standard"]}
          >
            Extension required
          </Text>
          <Text textStyle="body.medium.light">
            To use this feature, you need to download our Linkedin extension.
            Hit the button below to see the instructions.
          </Text>
          {session?.user?.uid ? (
            <Button
              mt={5}
              maxW="200px"
              variant={variant.Button.primary}
              // colorScheme="twitter"
              // as="a"
              // href={getAuthUrl(session)}
              // target="_blank"
              onClick={() => {
                // 
                // if (callback)
                //     callback();
                router.push("/connect");
              }}
            >
              Continue
            </Button>
          ) : (
            <Button mt={5} maxW="200px" variant={variant.Button.primary} isDisabled={true}>
              Continue
            </Button>
          )}
        </Center>
      </Box>
    );
}

